export default __webpack_public_path__ + "static/media/group.745abc45.svg";